var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 616.399,
    height: 522.237,
    viewBox: "0 0 616.399 522.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.i,.s{fill:#fff;}.b{fill:#8bded9;}.c,.e{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:6px;}.c{stroke:#dc8c2d;}.d{fill:#f0b441;}.e{stroke:#18beb3;}.f{clip-path:url(#a);}.g,.k{fill:#18beb3;}.h,.n{fill:#16192f;}.i{stroke:#fff;stroke-width:3px;}.j{fill:#0ba094;}.k{stroke:#16192f;stroke-width:2px;}.l{fill:#f4f5f7;}.m{fill:#ff8060;}.n{font-size:12px;font-family:CircularStd-Black, Circular Std;font-weight:800;}.o{fill:url(#b);}.p{fill:#4e4f58;}.q{fill:#525360;}.r{fill:rgba(107,114,128,0.15);}.s{font-size:9px;font-family:CircularStd-Book, Circular Std;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M835-1951.823c54.287-153.28,144.083,68.954,144.083,68.954l23.888,87.077S780.713-1798.543,835-1951.823Z",
    transform: "translate(-408 2957)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16192f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525252"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-655 -71)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(655 157.417)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 57.539)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M183.753,231.289c-.515-9.318-3.072-18.218-5.052-22.523-7.643-16.633-18.3-38.568-28.628-59.575,6.252-4.916,10.184-12.175,12.543-19.694,3.055-9.748,4.141-20.243,4.628-30.4a194.97,194.97,0,0,0-1.216-31.836,290.841,290.841,0,0,0-5.443-31.117c-1.132-4.973-2.337-9.929-3.677-14.846a44.2,44.2,0,0,0-3.225-8.809h0c-1.448-4.051-3.344-8.062-7.157-10.291-3.632-2.122-7.355-2.3-10.3-.238C133.88-.176,129.892-.408,126.91.508c-3.157.967-3.921,2.342-5.245,5.262-2.829-.566-6.314,1.59-7.762,4.243a16.7,16.7,0,0,0-.928,12.826c0,.39.028.786.068,1.182a1.833,1.833,0,0,0,1.086,1.55c1.33,2.642,2.931,4.034,6.025,3.3,4.062,17.109,8.69,37.833,9.793,46.472s1.765,20.226-1.55,20.4c-3.061.158-12.051-17.216-16.254-22.885-2.4-3.247-5.148-6.789-8.486-9.12-.164-.82-.322-1.641-.487-2.467-.645-3.276-1.239-6.574-1.731-9.884.04-.045.085-.085.119-.13,3.089-3.9,3.157-9.228,2.41-13.952a25.466,25.466,0,0,0-2.4-6.495c-.051-.17-.091-.339-.141-.5,3.96.187,3.27-6.789,2.665-8.136-2.936-6.585-9.51-8.577-13.98-5.148-1.318-1.748-3.875-1.7-5.9-.934a7.734,7.734,0,0,0-4.13,3.095c-1.307-.249-3.168-1.1-4.487-.764-2.9.752-6.116,2.829-7.559,8.69h0c-2.263,6.619-3.785,21.929-3.723,31.219a102.631,102.631,0,0,0-20.175,3.587C39.155,63.348,29.763,65.91,24.9,68.988c-4.288,1.918-9.267,4.622-13.013,6.7A20.9,20.9,0,0,0,1.707,88.422,25.459,25.459,0,0,0,.241,101.084c1.279,10.331,4.583,18.325,9.584,27.338.628,1.132,1.4,2.365,2.263,3.677,4.617,12.056,11.576,30.087,16.164,43.388,3.3,9.561,11.315,30.427,13.957,39.8,2.421,8.532,1.9,28.1.277,40.831-1.318,10.32-8.017,51.75-9.267,62.262-1.171,9.9-5.12,43.677-5.369,48.062s.911,8.023,4.345,8.023H88.263c4.526,0,2.212-5.262.622-6.789-2.982-2.829-6.082-6.744-9.081-9.55,1.194-7.576,1.975-15.23,3.247-22.783,2.025-12.045,12.13-72.35,13.646-84.3,1.38-10.851,2.9-31.683-4.1-52.26-2.263-6.682-4.769-13.278-7.4-19.8a34.783,34.783,0,0,0,9.171-5.307,40.518,40.518,0,0,0,5.6-5.482c3.083,6.472,6.02,12.65,8.2,17.25a275.035,275.035,0,0,1,11.513,27.722c4.147,12.005,4.843,17.629,4.4,28.543-.192,4.718-2.048,15.638-2.738,20.317-1.765,11.938-7.055,37.273-9.239,49.137-2.229,12.153-8.962,52.729-9.194,56.888s.724,6.416,3.627,6.416h61.832c2.67,0,3.208-3.208,1.347-5.59s-5.935-8.158-10.495-12.005c.334-1.986,10.184-43.564,14.37-62.556,2.354-10.67,4.735-21.2,6.993-31.92C182.695,252.38,184.273,240.607,183.753,231.289Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.331,34.45a37.85,37.85,0,0,0,7.83-.334,14.286,14.286,0,0,0,3.819,5.731A10.1,10.1,0,0,0,28.6,41.636c8.192-2.586,10.269-11.762,9.471-19.349-.091-.9-.192-1.844-.306-2.829l4.984-1.132c.9-.2,1.386-.905.984-1.556a50.489,50.489,0,0,0-10.9-12.5A11.762,11.762,0,0,0,28.219.788c-4.826-2.031-12.062.2-14.41,2.88s-2.9,7.706-2.6,11.592c.045.605.1,1.205.164,1.8a16.031,16.031,0,0,0-8.215,3.5A8.65,8.65,0,0,0,.293,29.325C1.216,32.708,4.01,34.218,7.331,34.45Z",
    transform: "translate(16.406 9.084)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(225.698 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,3.774A18.1,18.1,0,0,0,3.14,0",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,4.09C2.444,2.223,8.226,0,8.226,0",
    transform: "translate(5.782 16.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,.095,11.061.553",
    transform: "translate(13.454 47.067)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0,6.41,1.652",
    transform: "translate(14.648 67.122)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.072 12.7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M.436,3.666A49.419,49.419,0,0,1,3.095,10.88l8.871-1.7L18.252,8c-1.7-.758-2.716-2.7-3.757-5.346A14.8,14.8,0,0,1,13.742,0L10.348.639C6.919,1.284,3.462,1.941,0,2.586.17,2.965.311,3.315.436,3.666Z",
    transform: "translate(38.584 65.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M16.085,116.509A34.306,34.306,0,0,1,7.774,89.63c.746-5.12,3.61-13.239,9.233-22.472C12.65,67.746,6.789,68.73,0,69.941c.735-1.262,2.444-4.436,2.325-6.416a5.46,5.46,0,0,0-.905-2.67c7.321-1.285,13.335-2.247,17.5-2.693a37.837,37.837,0,0,1,4.4-.221c1.03-1.335,2.116-2.687,3.248-4.039,2.45-2.914,16.786-18.631,21.024-23.892C55.236,20.482,63.185,10.632,69.946.68A1.567,1.567,0,0,1,70.992.018a1.55,1.55,0,0,1,1.2.317C78.726,5.489,83.8,14,86.482,24.307c3.044,11.734,2.886,21.222-.543,31.654a1.561,1.561,0,0,1-.8.911,1.6,1.6,0,0,1-1.211.063A116.447,116.447,0,0,0,60.814,50.6C54.9,49.743,40.565,51.752,33.4,59.259a43.241,43.241,0,0,1,11.536,4.764,38.289,38.289,0,0,1,17.46,22.365A31.717,31.717,0,0,1,57.5,114.076c-5.318,7.208-13.386,11.621-21.572,11.8-.173,0-.345.006-.518.006C28.284,125.884,21.443,122.585,16.085,116.509Z",
    transform: "translate(76.439 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M5.073,9.216l.639-.107A79.807,79.807,0,0,1,7.41,0L3.625.639A4.349,4.349,0,1,0,5.073,9.216Z",
    transform: "translate(0 73.799)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.766 59.699)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M202.379.5H0",
    transform: "translate(0 372.621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M68.446,41.527c-12.3,1.7-25.986,2.223-35.869-5.29a51.157,51.157,0,0,1-6.552-6.314C20.243,23.649,0,0,0,0",
    transform: "translate(12.051 136.451)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M25.12,0c2.161,17.035,4.6,34.285,5.064,51,.209,7.672.413,17.584-3.366,18.885S15.677,66.149,13.3,61.962L0,38.472",
    transform: "translate(35.439 57.295)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M.154,18.193C-1.113,11.969,5.727,2.018,9.45.654S16.9.02,17.835,3.206s-2.987,8.543-4.871,9.873a12.555,12.555,0,0,1,8.39.724A7.98,7.98,0,0,1,24.086,17.2",
    transform: "translate(117.157 11.453)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M0,0C9.052,15.349,20.243,37.414,27.864,53.821",
    transform: "translate(118.771 91.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M5,0C1.736.854-.431,6.721.073,11.847",
    transform: "translate(127.343 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M4.057,0a8.583,8.583,0,0,1-.351,2.529A17.8,17.8,0,0,1,2.354,6.308,11.315,11.315,0,0,1,0,9.4",
    transform: "translate(135.795 6.206)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M.94,0C-.632,4.99-.31,10.851,2.5,15.276",
    transform: "translate(116.371 4.752)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1.041,0A6.67,6.67,0,0,0,0,2.376",
    transform: "translate(84.469 15.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1.363,0A4.4,4.4,0,0,0,0,2.467",
    transform: "translate(73.9 17.918)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M3.038,0c5.047,19.524,9.59,47.422,9.618,62.8S7.994,94.392,0,101.837",
    transform: "translate(98.183 63.354)"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(676.428 -880.259)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(422.316 1123.88)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.076 -41)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M47.353,35.5l-.46-17.353A13.854,13.854,0,0,1,53.516,5.8a19.279,19.279,0,0,1,20.616.374l13.886,9.2a1.829,1.829,0,0,1-.035,3.067c-1.1.673-25.15,15.408-37.654,2.917l.39,14.1V66.091a1.774,1.774,0,1,1-3.542,0Zm-10.2,30.592a1.81,1.81,0,0,0,.487,1.281,1.62,1.62,0,0,0,1.213.514,1.75,1.75,0,0,0,1.7-1.8V28.243a1.743,1.743,0,0,0-.354-1.085c-.708-1.122-9.989-14.436-24.371-6.844C11.966,22.708,4,27.383,3.96,27.383A1.756,1.756,0,0,0,3,28.8a1.88,1.88,0,0,0,.638,1.571c.5.411,12.221,10.06,23.7,8.078a17.188,17.188,0,0,0,9.706-5.2ZM95.1,63.136c0-.411-2.48-10.247-3.542-13.276a16.7,16.7,0,0,0-9.281-9.8,16.844,16.844,0,0,0-12.221.748L66.764,39.2a5.918,5.918,0,0,0-6.128.337,6.75,6.75,0,0,0-2.976,5.685V75.066H35.451a1.75,1.75,0,0,0-1.7,1.8v10.8a1.75,1.75,0,0,0,1.7,1.8h25.5V96.5h-25.5a1.873,1.873,0,0,0,0,3.74h27.2a1.62,1.62,0,0,0,1.213-.514,1.81,1.81,0,0,0,.487-1.281V87.67a1.81,1.81,0,0,0-.487-1.281,1.62,1.62,0,0,0-1.213-.514h-25.5V78.656h22.1a1.619,1.619,0,0,0,1.2-.5,1.808,1.808,0,0,0,.5-1.256V45.222a3.149,3.149,0,0,1,1.372-2.634,2.806,2.806,0,0,1,2.843-.171l2.586,1.309a14.366,14.366,0,0,0,1.771,11.631c6.163,9.275,23.025,9.873,23.733,9.873a1.734,1.734,0,0,0,1.381-.673,2.014,2.014,0,0,0,.461-1.421Z",
    transform: "translate(-2.998 -3)"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    transform: "translate(475.277 1053.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M45.621,31.6a4.86,4.86,0,0,0-1.538-1.588,7.69,7.69,0,0,0-1.972-.907c-.385-.119-.85-.242-1.38-.385-.427-.119-.892-.231-1.611-.385a14.454,14.454,0,0,1-2.188-.646,2.307,2.307,0,0,1-.9-.654,1.334,1.334,0,0,1-.273-.9V25.99a1.392,1.392,0,0,1,.273-.754,2.507,2.507,0,0,1,1.1-.769,6.094,6.094,0,0,1,2.192-.315,6.65,6.65,0,0,1,1.706.223,3.245,3.245,0,0,1,1.027.5,1.923,1.923,0,0,1,.5.523l.834,1.292,2.588-1.665-.834-1.292a4.972,4.972,0,0,0-1.28-1.353,6.29,6.29,0,0,0-1.984-.965,8.46,8.46,0,0,0-.842-.192V18H37.958v3.157a9.328,9.328,0,0,0-1.811.415,5.583,5.583,0,0,0-2.465,1.7l-.042.05a4.5,4.5,0,0,0-.961,2.63,4.422,4.422,0,0,0,.888,2.938l.05.065a5.383,5.383,0,0,0,2.222,1.611,17.522,17.522,0,0,0,2.645.769c.657.146,1.077.246,1.453.354h.042c.488.123.9.235,1.257.342a4.614,4.614,0,0,1,1.18.538,1.78,1.78,0,0,1,.538.561,1.815,1.815,0,0,1,.192.892v.069a1.753,1.753,0,0,1-.3,1.05,2.638,2.638,0,0,1-1.223.934,5.887,5.887,0,0,1-2.342.384h-.1a5.414,5.414,0,0,1-2.507-.531,2.757,2.757,0,0,1-.965-.869l-.877-1.265L32.31,35.545l.877,1.265a5.887,5.887,0,0,0,2.08,1.853l.042.019a8.57,8.57,0,0,0,2.649.788v3.138h3.076V39.4a8.609,8.609,0,0,0,1.707-.484,5.737,5.737,0,0,0,2.592-1.98,5.222,5.222,0,0,0,.315-5.3Z",
    transform: "translate(454.51 1041.468)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M0,7.942,6.526,0",
    transform: "translate(464.561 1060.422) rotate(-98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M0,7.942,6.526,0",
    transform: "translate(495.43 1040.051) rotate(-25.976)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M0,7.942,6.526,0",
    transform: "matrix(-0.485, -0.875, 0.875, -0.485, 463.019, 1072.449)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M0,7.942,6.526,0",
    transform: "translate(483.515 1042.301) rotate(-47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M0,7.942,6.526,0",
    transform: "translate(471.153 1050.555) rotate(-77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M0,7.942,6.526,0",
    transform: "translate(506.85 1043.272) rotate(-4.992)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1567.925-1928.852c17.476-10.8-33.127,1.264-33.127,1.264a19.617,19.617,0,0,0,9.857,4.312C1550.445-1922.319,1559.257-1923.5,1567.925-1928.852Z",
    transform: "translate(-1022.723 3029.073)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1536.15-1930.99l11.48,1.793,11.48,1.793",
    transform: "translate(-1019.723 3024.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1575.9-1881.017c-.9,6.4-7.891-7.678-14.222-14.943-5.933-6.807-11.209-6.8-11.209-6.8s8.622-5,16.385.676C1571.734-1898.517,1576.63-1886.2,1575.9-1881.017Z",
    transform: "translate(-1019.723 3024.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1536.15-1930.99l8.485,1.127,8.485,1.127",
    transform: "translate(-1840.141 1787.424) rotate(36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1486.015-1908.916c4.444,4.6,33.4-4.773,33.4-4.773s-3.047-1.865-10.714-3.581a25.913,25.913,0,0,0-8.433-.589c-1.743.2-3.4.97-5.27,1.12C1491.448-1916.453,1485.561-1909.369,1486.015-1908.916Z",
    transform: "translate(2349.334 -445.594) rotate(-167.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1536.15-1930.99l8.485,1.127,8.485,1.127",
    transform: "translate(-625.801 3317.885) rotate(-12.007)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(636 -282.637)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M6.786,0H380.648a6.889,6.889,0,0,1,6.786,6.989V263.457a6.889,6.889,0,0,1-6.786,6.989H6.786A6.889,6.889,0,0,1,0,263.456V6.989A6.889,6.889,0,0,1,6.786,0Z",
    transform: "translate(247.352 545.261)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M6.169,0H381.26a6.169,6.169,0,0,1,6.169,6.169V26.528H0V6.169A6.169,6.169,0,0,1,6.169,0Z",
    transform: "translate(247.351 545.425)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "m",
    cx: 1.542,
    cy: 1.851,
    rx: 1.542,
    ry: 1.851,
    transform: "translate(259.69 556.53)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 1.851,
    cy: 1.851,
    r: 1.851,
    transform: "translate(267.093 556.53)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 1.851,
    cy: 1.851,
    r: 1.851,
    transform: "translate(275.113 556.53)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(267.71 597.624)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VC Investor")), /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(393.562 597.624)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Angel Investor")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(267.828 612.303)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M7.85,0H338.872c4.336,0,7.85,3.17,7.85,7.081V33.045H0V7.081C0,3.17,3.516,0,7.85,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.674 9.993)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M11.388,0h11.82a7.388,7.388,0,1,1,0,14.775H11.388A7.388,7.388,0,1,1,11.388,0Z",
    transform: "translate(-4 0.001)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M11.388,0H41.715a7.388,7.388,0,1,1,0,14.775H11.388A7.388,7.388,0,1,1,11.388,0Z",
    transform: "translate(209.462 9.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M11.388,0H41.715a7.388,7.388,0,1,1,0,14.775H11.388A7.388,7.388,0,1,1,11.388,0Z",
    transform: "translate(283.493 9.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M11.388,0H54.054a7.388,7.388,0,1,1,0,14.775H11.388A7.388,7.388,0,1,1,11.388,0Z",
    transform: "translate(14.389 9.993)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 346.712,
    height: 147.445,
    transform: "translate(267.71 645.367)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(286.218 655.855)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M16.728,14.243l-1-2.025-1,2.025a.456.456,0,0,1-.344.247l-2.233.325,1.616,1.576a.456.456,0,0,1,.131.4l-.382,2.226,2-1.049a.456.456,0,0,1,.424,0l2,1.049-.382-2.226a.456.456,0,0,1,.131-.4l1.617-1.576-2.233-.325A.456.456,0,0,1,16.728,14.243Z",
    transform: "translate(-8.403 -8.404)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M9.335,2A7.335,7.335,0,1,0,16.67,9.335,7.335,7.335,0,0,0,9.335,2ZM13.7,8.494l-1.887,1.834.445,2.591a.408.408,0,0,1-.591.432L9.334,12.129,7.007,13.351a.408.408,0,0,1-.591-.432l.445-2.591L4.975,8.494A.408.408,0,0,1,5.2,7.8l2.6-.378,1.167-2.36a.424.424,0,0,1,.731,0l1.164,2.36,2.6.378a.408.408,0,0,1,.226.7Z",
    transform: "translate(-2 -2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 144.71,
    height: 9.499,
    rx: 4.75,
    transform: "translate(21.457 2.457)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 39.354,
    height: 9.499,
    rx: 4.75,
    transform: "translate(199.793 2.457)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 39.354,
    height: 9.499,
    rx: 4.75,
    transform: "translate(276.077 2.457)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(286.07 683.616)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M16.728,14.243l-1-2.025-1,2.025a.456.456,0,0,1-.344.247l-2.233.325,1.616,1.576a.456.456,0,0,1,.131.4l-.382,2.226,2-1.049a.456.456,0,0,1,.424,0l2,1.049-.382-2.226a.456.456,0,0,1,.131-.4l1.617-1.576-2.233-.325A.456.456,0,0,1,16.728,14.243Z",
    transform: "translate(-8.403 -8.404)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M9.335,2A7.335,7.335,0,1,0,16.67,9.335,7.335,7.335,0,0,0,9.335,2ZM13.7,8.494l-1.887,1.834.445,2.591a.408.408,0,0,1-.591.432L9.334,12.129,7.007,13.351a.408.408,0,0,1-.591-.432l.445-2.591L4.975,8.494A.408.408,0,0,1,5.2,7.8l2.6-.378,1.167-2.36a.424.424,0,0,1,.731,0l1.164,2.36,2.6.378a.408.408,0,0,1,.226.7Z",
    transform: "translate(-2 -2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 144.71,
    height: 9.499,
    rx: 4.75,
    transform: "translate(21.457 2.458)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 39.354,
    height: 9.499,
    rx: 4.75,
    transform: "translate(199.793 2.458)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 39.354,
    height: 9.499,
    rx: 4.75,
    transform: "translate(276.077 2.458)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(286.07 710.762)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M16.728,14.243l-1-2.025-1,2.025a.456.456,0,0,1-.344.247l-2.233.325,1.616,1.576a.456.456,0,0,1,.131.4l-.382,2.226,2-1.049a.456.456,0,0,1,.424,0l2,1.049-.382-2.226a.456.456,0,0,1,.131-.4l1.617-1.576-2.233-.325A.456.456,0,0,1,16.728,14.243Z",
    transform: "translate(-8.403 -8.404)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M9.335,2A7.335,7.335,0,1,0,16.67,9.335,7.335,7.335,0,0,0,9.335,2ZM13.7,8.494l-1.887,1.834.445,2.591a.408.408,0,0,1-.591.432L9.334,12.129,7.007,13.351a.408.408,0,0,1-.591-.432l.445-2.591L4.975,8.494A.408.408,0,0,1,5.2,7.8l2.6-.378,1.167-2.36a.424.424,0,0,1,.731,0l1.164,2.36,2.6.378a.408.408,0,0,1,.226.7Z",
    transform: "translate(-2 -2)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 144.71,
    height: 9.499,
    rx: 4.75,
    transform: "translate(21.457 2.458)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 39.354,
    height: 9.499,
    rx: 4.75,
    transform: "translate(199.793 2.458)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 39.354,
    height: 9.499,
    rx: 4.75,
    transform: "translate(276.077 2.458)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "s",
    transform: "translate(356.547 633.392)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "***")), /*#__PURE__*/React.createElement("text", {
    className: "n",
    transform: "translate(535.455 597.624)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Family Office")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(286.07 738.523)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M16.728,14.243l-1-2.025-1,2.025a.456.456,0,0,1-.344.247l-2.233.325,1.616,1.576a.456.456,0,0,1,.131.4l-.382,2.226,2-1.049a.456.456,0,0,1,.424,0l2,1.049-.382-2.226a.456.456,0,0,1,.131-.4l1.617-1.576-2.233-.325A.456.456,0,0,1,16.728,14.243Z",
    transform: "translate(-8.403 -8.404)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M9.335,2A7.335,7.335,0,1,0,16.67,9.335,7.335,7.335,0,0,0,9.335,2ZM13.7,8.494l-1.887,1.834.445,2.591a.408.408,0,0,1-.591.432L9.334,12.129,7.007,13.351a.408.408,0,0,1-.591-.432l.445-2.591L4.975,8.494A.408.408,0,0,1,5.2,7.8l2.6-.378,1.167-2.36a.424.424,0,0,1,.731,0l1.164,2.36,2.6.378a.408.408,0,0,1,.226.7Z",
    transform: "translate(-2 -2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 144.71,
    height: 9.499,
    rx: 4.75,
    transform: "translate(21.457 2.457)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 39.354,
    height: 9.499,
    rx: 4.75,
    transform: "translate(199.793 2.457)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 39.354,
    height: 9.499,
    rx: 4.75,
    transform: "translate(276.077 2.457)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(286.07 765.667)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M16.728,14.243l-1-2.025-1,2.025a.456.456,0,0,1-.344.247l-2.233.325,1.616,1.576a.456.456,0,0,1,.131.4l-.382,2.226,2-1.049a.456.456,0,0,1,.424,0l2,1.049-.382-2.226a.456.456,0,0,1,.131-.4l1.617-1.576-2.233-.325A.456.456,0,0,1,16.728,14.243Z",
    transform: "translate(-8.403 -8.404)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M9.335,2A7.335,7.335,0,1,0,16.67,9.335,7.335,7.335,0,0,0,9.335,2ZM13.7,8.494l-1.887,1.834.445,2.591a.408.408,0,0,1-.591.432L9.334,12.129,7.007,13.351a.408.408,0,0,1-.591-.432l.445-2.591L4.975,8.494A.408.408,0,0,1,5.2,7.8l2.6-.378,1.167-2.36a.424.424,0,0,1,.731,0l1.164,2.36,2.6.378a.408.408,0,0,1,.226.7Z",
    transform: "translate(-2 -2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 144.71,
    height: 9.499,
    rx: 4.75,
    transform: "translate(21.457 2.458)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 39.354,
    height: 9.499,
    rx: 4.75,
    transform: "translate(199.793 2.458)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 39.354,
    height: 9.499,
    rx: 4.75,
    transform: "translate(276.077 2.458)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.286643c84de8a77755bf451b0a534211.svg";
export { ForwardRef as ReactComponent };